import { NftDevelopmentPage } from './NftDevelopmentPage';

export default NftDevelopmentPage;
